import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

// Én egen ordre. order er null når den ikke finnes eller brukeren ikke har tilgang.
export function useCarrierOrder(orderId) {
  const [state, setState] = useState({ order: null, loading: Boolean(orderId) });

  useEffect(() => {
    if (!orderId) {
      setState({ order: null, loading: false });
      return undefined;
    }
    setState(s => ({ ...s, loading: true }));
    return onSnapshot(
      doc(db, 'orders', orderId),
      snap => setState({ order: snap.exists() ? { id: snap.id, ...snap.data() } : null, loading: false }),
      () => setState({ order: null, loading: false }),
    );
  }, [orderId]);

  return state;
}
